module.exports = __webpack_public_path__ + "img/about_banner_en.e026d82b.jpg";